<template>
    <div>
        <div v-show="mostrarMenu">
            <b-card no-body>
                <b-card-header>
                    <h5>Relatorios</h5>
                </b-card-header>
                <b-card-body>
                    <relatorios-credenciados></relatorios-credenciados>
                    <relatorios-sgtec></relatorios-sgtec>
                    <paineis-menu></paineis-menu>
                    <relatorios-tcu></relatorios-tcu>
                    <avaliacoes-menu></avaliacoes-menu>
                </b-card-body>
            </b-card>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import RelatoriosCredenciados from './../credenciados/relatorios/Relatorios'
import RelatoriosSgtec from './../sgtec/relatorios/Relatorios'
// import RelatoriosServicos from './RelatoriosServicos'
import PaineisMenu from './../paineis/PaineisMenu.vue'
import RelatoriosTcu from './../tcu/relatorios/Relatorios.vue'
import AvaliacoesMenu from './../despesasgerais/avaliacoes/AvaliacoesMenu.vue'

export default {
    components: {
        RelatoriosCredenciados,
        RelatoriosSgtec,
        PaineisMenu,
        RelatoriosTcu,
        AvaliacoesMenu
    },

    computed: {
        mostrarMenu() {
            return this.$route.name == 'Relatorios'
        }
    }
}
</script>
